import PocketBase from "pocketbase";
import type { TenancyUser } from "./types";

// Empty base URL = same-origin, relative requests. The Vite dev server proxies
// /api and /8004 to the local PocketBase server (see vite.config.ts); in
// production the portal is served by the same PocketBase binary.
export const PB_URL = import.meta.env.VITE_PB_URL || "";

// The SDK must get "/" (not "") for the same-origin case: given an empty base it
// resolves API paths relative to the *current page* (e.g. on /signup it would
// POST to /signup/api/... → 404). A "/" base always resolves against the origin
// root. api.ts keeps using PB_URL ("") for its own "/api/dpp/..." paths, which
// are already origin-relative.
export const pb = new PocketBase(PB_URL || "/");

export const USERS_COLLECTION = "tenancy_users";

/** The currently authenticated tenancy_users record, if any. */
export function currentUser(): TenancyUser | null {
  return pb.authStore.record as unknown as TenancyUser | null;
}

export function isLoggedIn(): boolean {
  return pb.authStore.isValid;
}

export function hasOrganization(): boolean {
  return !!currentUser()?.organization;
}

export function hasRole(role: string): boolean {
  return currentUser()?.roles?.includes(role) ?? false;
}

export function logout(): void {
  pb.authStore.clear();
}
